import React, { useEffect, useState } from 'react'
import { getIsManualReviewLoading, getOcrStepFunctionStatus } from '../ducks/selectors';
import { Box, Button, Image, ListItem, OrderedList, Text } from '@chakra-ui/react';
import { TRANSFER_UPLOAD_V2 } from '@/utils/constants';

const DocumentValidationError = ({ documentTypeLabel, OnUploadNewFile, onMannualRequest }: any) => {
    const [errorMsg, setErrorMsg] = useState('')

    const ocrStepFunctionStatus: any = getOcrStepFunctionStatus();
    const isManualReviewLoading = getIsManualReviewLoading();


    useEffect(() => {
        if (ocrStepFunctionStatus.status !== 0 && ocrStepFunctionStatus.status !== null) {
            if (ocrStepFunctionStatus.status === 12) {
                setErrorMsg(`Our automated system couldn't recognize the FFL license number of or expiration date of your license, so will send to our compliance staff for manual review and approval.`)
            }
            if (ocrStepFunctionStatus.status === 58) {
                setErrorMsg(`The uploaded document does not meet our image quality or authenticity checks (for example it may be unclear, incomplete, or altered). Your file will be sent to our compliance staff for manual review and approval.`)
            }
            if (ocrStepFunctionStatus.status === 59) {
                setErrorMsg(`Missing PositionTitle / PrintedName / PrintedDate on the FFL could not be confirmed from your document. Your file will be sent to our compliance staff for manual review and approval.`)
            }
            if (ocrStepFunctionStatus.status === 14 || ocrStepFunctionStatus.status === 16) {
                setErrorMsg(`The uploaded document does not appear to be a valid ${documentTypeLabel}. Please upload the correct document.`)
            }
            if (ocrStepFunctionStatus.status === 15) {
                setErrorMsg(`This document is already under review. No further action is needed at this time.`)
            }
            if (ocrStepFunctionStatus.status === 33 || ocrStepFunctionStatus.status === 51) {
                setErrorMsg(`Unable to verify this license. eZ-Check Failed.`);
            }
            if (ocrStepFunctionStatus.status === 30) {
                setErrorMsg(`We were unable to verify the license through eZ-Check, so will send to our compliance staff for manual review and approval.`)
            }
            if (ocrStepFunctionStatus.status === 52) {
                setErrorMsg(`The uploaded document does not match the what we are expecting for this upload. Please upload the correct document.`)
            }
            if (ocrStepFunctionStatus.status === 54) {
                setErrorMsg(`The uploaded document has expired. Please provide a valid license.`)
            }
            if (ocrStepFunctionStatus.status === 55) {
                setErrorMsg(`The address has been updated through ATF and is pending global admin approval. No action is required on your end.`)
            }
            if (ocrStepFunctionStatus.status === 10 || ocrStepFunctionStatus.status === 50 || ocrStepFunctionStatus.status === 71 || ocrStepFunctionStatus.status === 13) {
                setErrorMsg(`An unexpected error occurred. Your document will be reviewed by our compliance staff.`)
            }
            if (ocrStepFunctionStatus.status === 18) {
                setErrorMsg(`You have uploaded SOT tax receipt for next year. It is being retained for and we will start using it automatically from 07/01 but in order to process current transfers, we still need your current SOT which is valid until 06/30 this year.`)
            }
            if (ocrStepFunctionStatus.status === 57) {
                setErrorMsg(`We could not clearly detect the license signature on your document. Your file will be sent to our compliance staff for manual review and approval.`)
            }
        }

    }, [ocrStepFunctionStatus]);


    return (
        <>
            {errorMsg && (
                <Box className="errorFromDev">
                    {errorMsg}
                </Box>
            )}
            {ocrStepFunctionStatus.status !== 15 && (
                <Box
                    className="Upload-Dropbox-Error"
                    onDragOver={(e: any) => e.preventDefault()}
                >
                    <Image
                        src="/images/ui/Isolation_Mode.png"
                        alt=""
                        className="errorFile-icon"
                    />
                    <Text className="select-title-error">Document Validation Failed</Text>
                    <Box>
                        {ocrStepFunctionStatus.status !== 18 && (
                            <>
                            <Text className="validation-error-desc">
                                {TRANSFER_UPLOAD_V2.DOCUMENT_VALIDATION_FAILED_DESC}
                            </Text>
                            <OrderedList>
                                <ListItem className="validation-error-desc">
                                    {TRANSFER_UPLOAD_V2.DOCUMENT_VALIDATION_NEW_TITLE}
                                </ListItem>
                                {ocrStepFunctionStatus.status !== 18 && (
                                    <ListItem className="validation-error-desc">
                                        {TRANSFER_UPLOAD_V2.DOCUMENT_VALIDATION_NEW_DESC}
                                    </ListItem>
                                )}
                            </OrderedList>
                            </>
                        )}
                    </Box>
                    <Box
                        style={{
                            display: "flex",
                            gap: "8px",
                            marginTop: "8px",
                            flexWrap: "wrap",
                            justifyContent: "center",
                        }}
                    >
                        <Button
                            background="#0C1E460D"
                            padding="8px 20px"
                            display={"flex"}
                            border="1px #0C1E46 solid"
                            color="#0C1E46"
                            alignItems={"center"}
                            gap={"10px"}
                            onClick={OnUploadNewFile}
                            width={{ base: "100%", md: "auto", lg: "auto" }}
                        >
                            <Image
                                src="/images/ui/UploadFillIcon.png"
                                alt=""
                                height={22}
                                width={22}
                            />
                            {TRANSFER_UPLOAD_V2.UPLOAD_NEW_FILE_BTN}
                        </Button>
                        {ocrStepFunctionStatus.status !== 18 && (
                            <Button
                                colorScheme="blue"
                                background="#0C1E46"
                                padding="8px 20px"
                                display={"flex"}
                                alignItems={"center"}
                                gap={"10px"}
                                className="themebtn"
                                isLoading={isManualReviewLoading}
                                onClick={onMannualRequest}
                                width={{ base: "100%", md: "auto", lg: "auto" }}
                            >
                                <Image src="/images/ui/eyeIcon.png" alt="" height={22} width={22} />
                                {TRANSFER_UPLOAD_V2.REQUEST_FOR_MANNUAL_REVIEW_BTN}
                            </Button>
                        )}
                    </Box>
                </Box>
            )}
        </>
    )
}

export default DocumentValidationError    